import IconButton from "components/Common/IconButton/IconButton"
import PrimaryButton from "newcomponents/primary-button"
import React from "react"
import { useNavigate } from "react-router-dom"
import { Card, CardBody, CardTitle, Col, Row } from "reactstrap"
import AddIcon from "@mui/icons-material/Add"

const SurveyForm = ({
  formData,
  setFormData,
  toggleTemplateModal,
  colors,
  mode,
}) => {
  const navigate = useNavigate()

  const addNewSurvey = () => {
    console.log("formdata", formData)
    setFormData(prevState => ({
      ...prevState,
      survey: [
        ...prevState.survey,
        {
          surveyId: null,
          title: "",
          description: "",
          questions: [],
          audiences: [],
          threshold: 8,
        },
      ],
    }))
  }
  return (
    // <div>
    //   <Row className="justify-content-center">
    //     <Col xl={12}>
    //       <Card className="shadow-sm">
    //         <CardBody>
    //           <Row className="align-items-center">
    //             <Col xl={6} lg={6} md={6} className="d-flex align-items-center">
    //               <CardTitle className="h4 mb-0 text-uppercase text-primary">
    //                 Add Form
    //               </CardTitle>
    //             </Col>
    //             <Col
    //               xl={6}
    //               lg={6}
    //               md={6}
    //               className="d-flex justify-content-end align-items-center gap-2"
    //             >
    //               <IconButton
    //                 color="info"
    //                 size="md"
    //                 onClick={toggleTemplateModal}
    //                 text="Select a Template"
    //                 icon="mdi-plus"
    //               />
    //               <IconButton
    //                 color="primary"
    //                 size="md"
    //                 onClick={addNewSurvey}
    //                 text="Create Custom Survey"
    //                 icon="mdi-plus"
    //               />
    //             </Col>
    //           </Row>
    //         </CardBody>
    //       </Card>
    //     </Col>
    //   </Row>
    // </div>
    <div
      style={{
        backgroundColor: mode === "dark" ? "#252f40" : "#fff",
        marginTop: "0px",
        padding: "20px 20px",
        fontFamily: "Inter",
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        color: mode === "dark" ? "#fff" : "#050409",
        fontWeight: "600",
        fontSize: "23px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: "20px",
      }}
    >
      {/* Left side: org name */}
      <h2
        style={{
          margin: 0,
          fontSize: "20px",
          color: colors.text,
          fontWeight: 500,
        }}
      >
        Add Survey
      </h2>

      {/* Right side: date inputs + button */}
      <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
        <button
          type="button"
          onClick={toggleTemplateModal}
          style={{
            backgroundColor: mode === "dark" ? "#252f40" : "#fff",
            color: "white",
            border: "1px solid #2990DF",
            borderRadius: "4px",
            cursor: "pointer",
            fontWeight: "400",
            fontFamily: "Inter",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "6px",
            color: "#2990DF",
            padding: "10px 30px",
            fontSize: "15px",
            fontWeight: "500",
            borderRadius: "8px",
          }}
        >
          Select a Template
          <AddIcon />
        </button>
        {/* Create New Button */}
        <PrimaryButton
          style={{
            padding: "10px 30px",
            fontSize: "15px",
            fontWeight: "500",
            borderRadius: "8px",
          }}
          icon={<AddIcon />}
          onClick={addNewSurvey}
        >
          Create New Survey
        </PrimaryButton>
      </div>
    </div>
  )
}

export default SurveyForm
